module.exports = __webpack_public_path__ + "img/download-icon.8b1e2a76.jpg";